import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import PublicLayout from './components/PublicLayout'

// Lazy load pages for better initial load performance
const Dashboard = lazy(() => import('./pages/Dashboard'))
const LiveGames = lazy(() => import('./pages/LiveGames'))
const Predictions = lazy(() => import('./pages/Predictions'))
const GamePage = lazy(() => import('./pages/GamePage'))
const History = lazy(() => import('./pages/History'))
const Analytics = lazy(() => import('./pages/Analytics'))
const Leaderboards = lazy(() => import('./pages/Leaderboards'))
const Players = lazy(() => import('./pages/Players'))
const TeamProfile = lazy(() => import('./pages/TeamProfile'))
const Tools = lazy(() => import('./pages/Tools'))
const NotFound = lazy(() => import('./pages/NotFound'))

// Loading spinner for lazy-loaded pages
function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="w-8 h-8 border-2 border-accent-cyan border-t-transparent rounded-full animate-spin" />
    </div>
  )
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        <Route index element={
          <Suspense fallback={<PageLoader />}>
            <Dashboard />
          </Suspense>
        } />
        <Route path="live" element={
          <Suspense fallback={<PageLoader />}>
            <LiveGames />
          </Suspense>
        } />
        <Route path="predictions" element={
          <Suspense fallback={<PageLoader />}>
            <Predictions />
          </Suspense>
        } />
        {/* SEO-friendly game pages: /nfl/chiefs-vs-bills */}
        <Route path=":sport/:matchup" element={
          <Suspense fallback={<PageLoader />}>
            <GamePage />
          </Suspense>
        } />
        <Route path="history" element={
          <Suspense fallback={<PageLoader />}>
            <History />
          </Suspense>
        } />
        <Route path="analytics" element={
          <Suspense fallback={<PageLoader />}>
            <Analytics />
          </Suspense>
        } />
        <Route path="leaderboards" element={
          <Suspense fallback={<PageLoader />}>
            <Leaderboards />
          </Suspense>
        } />
        <Route path="players" element={
          <Suspense fallback={<PageLoader />}>
            <Players />
          </Suspense>
        } />
        <Route path="team/:teamId" element={
          <Suspense fallback={<PageLoader />}>
            <TeamProfile />
          </Suspense>
        } />
        <Route path="tools" element={
          <Suspense fallback={<PageLoader />}>
            <Tools />
          </Suspense>
        } />
        <Route path="*" element={
          <Suspense fallback={<PageLoader />}>
            <NotFound />
          </Suspense>
        } />
      </Route>
    </Routes>
  )
}

export default App
